import { ButtonProps, useTheme } from '@mui/material'
import { designTokens } from '@/theme'
import AppButton from '@/components/ui/AppButton'

const SecondaryButton = (props: ButtonProps) => {
  const theme = useTheme()

  return (
    <AppButton
      variantType="neutral"
      {...props}
      sx={{
        borderRadius: `${designTokens.shape.borderRadius.xl}px`,
        py: 1.6,
        textTransform: 'none',
        fontWeight: 600,
        fontSize: (t) => t.typography.body1.fontSize,
        borderColor: theme.palette.divider,
        color: theme.palette.text.primary,
        backgroundColor: 'transparent',
        boxShadow: 'none',
        transition: `all ${designTokens.motion.normal}`,

        '&:hover': {
          backgroundColor: theme.palette.action.hover,
          borderColor: theme.palette.text.secondary,
        },

        '&:active': {
          transform: 'scale(0.98)',
        },

        ...props.sx,
      }}
    />
  )
}

export default SecondaryButton
